import { fluxLogger } from '../core/services/logger/logger.instance.js';

export const sharedLogger = fluxLogger.extend('shared');
